<template>
  <div v-click-outside="() => (isOpenLoginMenu = false)" class="relative">
    <button
      class="w-[max-content] group flex justify-center bg-[initial] xl:p-0 items-center h-[32px] md:h-[44px] hover:text-secondary rounded-[5px] p-1 xl:min-w-[120px]"
      :class="{ 'text-secondary-pressed': isOpenLoginMenu }"
      @click="handleLoginTypeMenu"
    >
      <div class="md:flex justify-center w-[24px] h-[24px] md:w-[32px] md:h-[32px]">
        <icon-profile
          class="group-active:text-secondary-pressed group-hover:text-secondary text-[#242D21]"
          :class="{ 'text-secondary-pressed': isOpenLoginMenu }"
        ></icon-profile>
      </div>
      <span
        class="text-[18px] font-medium font-Montserrat hidden xl:block group-active:text-secondary-pressed group-hover:text-secondary"
        >{{ $t("common.login") }}</span
      >
      <icon-arrow-list
        class="hidden xl:block ml-2 w-[12px] h-[12px]"
        :class="{
          'rotate-180': isOpenLoginMenu,
        }"
      />
    </button>

    <div
      v-show="isOpenLoginMenu"
      class="absolute xl:left-0 left-[-150%] xl:top-[100%] top-[105%] bg-white z-[99999] py-[12px] px-4 border-secondary border-[2px] rounded-[10px] flex flex-col gap-2"
    >
      <button
        v-for="loginType in loginTypes"
        :key="loginType.label"
        class="w-[max-content] gap-[8px] flex items-center text-black group leading-none"
        :data-type="loginType.value"
        @click="gotoLogin"
      >
        <component :is="loginType.icon" class="group-hover:text-secondary-hover w-6 h-6"></component>
        <span
          :data-type="loginType.value"
          class="shrink-0 xl:text-[18px] text-[16px] underline group-hover:text-secondary-hover"
          >{{ $t(loginType.label) }}</span
        >
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue"
import { useRouter } from "vue-router"
import IconManagerAcc from "@/components/icons/IconManagerAcc.vue"
import IconVendorAcc from "@/components/icons/IconVendorAcc.vue"
import IconProfile from "@/components/icons/IconProfile.vue"
import { MANAGER_URL, VENDOR_URL } from "@/api/urls"

const loginTypes = [
  {
    value: "vendor",
    label: "common.seller",
    icon: IconVendorAcc,
  },
  {
    value: "manager",
    label: "common.partner",
    icon: IconManagerAcc,
  },
]

const router = useRouter()

const isOpenLoginMenu = ref(false)

const handleLoginTypeMenu = () => {
  isOpenLoginMenu.value = !isOpenLoginMenu.value
}

const gotoLogin = ({ target }) => {
  const type = target.dataset.type
  switch (type) {
    case "current":
      router.push({ name: "/profile/details/account" })
      break
    case "vendor":
      window.open(`${VENDOR_URL}/login`)
      break
    case "manager":
      window.open(`${MANAGER_URL}/login`)
      break
    default:
      return false
  }
}
</script>
